import React from 'react'
import linkedin from '../images/linkedin.png'
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import Shine from '../images/shine.png'
import iim from '../images/iim.png'
import indeed from '../images/indeed.png'
import foundit from '../images/foundit.png'
import naukri from '../images/naukri.png'
import hirist from '../images/hirist.png'
import times from '../images/times.png';
const Board = () => {
  return (
    <div>
      <div className="bg-[#f0f4fc] min-h-screen">
        <div className=" px-10 pt-5">
          
          <div className="p-4 mt-6 bg-white w-full rounded-xl">
            <p className="text-[#263871] font-semibold">Select job boards</p>
            
          <div className="grid grid-cols-2 gap-4 mt-5">
            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={linkedin} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Linkedin</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About LinkedIn</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={Shine} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Shine</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Shine</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={iim} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">IIM Jobs</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About IIM Jobs</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={indeed} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Indeed</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Indeed</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={foundit} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Foundit</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Foundit</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={naukri} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Naukri.com</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Naukri.com</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={hirist} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Hirist</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Hirist</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

            <div className="p-4 rounded-lg border">
              <div className="flex w-full items-center justify-between">
              <div className="flex space-x-3">
              <img src={times} className="p-3 bg-gray-100 h-16 rounded-xl "></img>
              <div>
              <p className="text-[#424E79] mt-1 text-xl font-semibold">Times Jobs</p>
              <p className="text-sm my-1 text-[#9BA5CA]">Worldwide</p>
              </div>
              </div>
              <Toggle></Toggle>
              </div>
              
            <div className="w-full py-[0.02rem] my-6 bg-slate-500"></div>
            <div className="flex items-center justify-between">
            <a>About Times Jobs</a>
            <p className="bg-[#0DCD94] bg-opacity-25 px-4 py-2 text-sm font-semibold rounded-xl text-[#0DCD94]">Free</p>
            </div>
            </div>

           
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Board